(function () {
    'use strict';

    angular
        .module('app')
        .run(run);

    run.$inject = ['global', 'load', '$q', '$transitions', '$rootScope', '$state', 'alert',];

    function run(global, load, $q, $transitions, $rootScope, $state, alert) {
        $transitions.onExit({}, function (/*transition*/) {
            if ($rootScope.confirmLeaveForm) {
                // eslint-disable-next-line no-undef
                return new Promise(function(resolve, reject){
                    alert.confirm('confirm-leave-form').then(function() {
                        $rootScope.confirmLeaveForm = false;

                        resolve();
                    }, reject);
                });

                /*transition.abort();

                alert.confirm('confirm-leave-form')
                    .then(function () {
                        $rootScope.confirmLeaveForm = false;
                        $state.go(transition.to().name);
                    }, function () {
                    });*/
            }
        });
    }
})();